import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface SearchState {
  searchHistory: string[];
  addSearch: (search: string) => void;
  removeSearch: (search: string) => void;
  clearSearchHistory: () => void;
}

export const useSearchStore = create<SearchState>()(
  devtools(
    persist(
      (set) => ({
        searchHistory: [],

        addSearch: (search: string) =>
          set((state) => ({
            searchHistory: Array.from(new Set([...state.searchHistory, search])),
          })),
        removeSearch: (search: string) =>
          set((state) => ({
            searchHistory: state.searchHistory.filter((item) => item !== search),
          })),

        clearSearchHistory: () =>
          set(() => ({
            searchHistory: [],
          })),
      }),
      {
        name: 'search-storage',
      },
    ),
  ),
);
